// services/restaruant.service.js
// 📍 Location: frontend/services/restaruant.service.js

import { apiService } from "../../app.service";

export const restaruantapi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ EXISTING - Fetch all restaurants (Super Admin only)
    fetchRestaurantData: builder.query({
      query: () => ({
        url: "/restaurant",
      }),
      providesTags: ["restaurants"],
    }),
    
    // ✅ EXISTING - Fetch restaurant by ID
    fetchRestaurantDataById: builder.query({
      query: (id) => ({
        url: `/restaurant/${id}`,
      }),
      providesTags: (result) =>
        result ? [{ type: "restaurant", id: result._id }] : [],
    }),
    
    // ✅ UPDATE - Fetch self restaurant with location support
    fetchSelfRestaurantData: builder.query({
      query: (locationId) => ({
        url: `/auth/restaurant`,
        params: locationId ? { locationId } : {},
      }),
      providesTags: ["Restaurant"],
    }),
    
    // ✅ EXISTING - Add restaurant
    addRestaurantData: builder.mutation({
      query: (data) => ({
        url: "/restaurant",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["restaurants"],
    }),
    
    // ✅ EXISTING - Edit restaurant
    editRestaurantData: builder.mutation({
      query: ({ id, data }) => ({
        url: `/restaurant/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "restaurant", id },
        "restaurants",
      ],
    }),
    
    // ✅ EXISTING - Delete restaurant
    deleteRestaurantData: builder.mutation({
      query: (data) => ({
        url: "/restaurant/" + data,
        method: "DELETE",
      }),
      invalidatesTags: ["restaurants"],
    }),
    
    // ✅ EXISTING - Update restaurant settings
    updateRestaurantSetting: builder.mutation({
      query: (data) => ({
        url: "/restaurant/setting",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: "restaurant", id }],
    }),

    // ============================================
    // ✅ NEW - MULTI-LOCATION APIs
    // ============================================

    // ✅ Get all locations for current user
    fetchMyLocations: builder.query({
      query: () => ({
        url: "/restaurant/my-locations",
      }),
      providesTags: ["MyLocations"],
    }),

    // ✅ Switch active location
    switchLocation: builder.mutation({
      query: (data) => ({
        url: "/restaurant/switch-location",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Restaurant", "MyLocations", "Checklists", "Reports"],
    }),

    // ✅ Add new location
    addLocation: builder.mutation({
      query: (data) => ({
        url: "/restaurant/location",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["MyLocations", "Restaurant"],
    }),

    // ✅ Delete location
    deleteLocation: builder.mutation({
      query: (locationId) => ({
        url: `/restaurant/location/${locationId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["MyLocations", "Restaurant"],
    }),

   createLocationPaymentIntent: builder.mutation({
      query: (data) => ({
        url: "/payment/create-payment-intent",
        method: "POST",
        body: data,
      }),
    }),

    // ✅ NEW: Check payment status
    checkPaymentStatus: builder.query({
      query: (paymentIntentId) => ({
        url: `/payment/check-location-status/${paymentIntentId}`,
      }),
    }),

    
  }),

  
});




export const {
  // ✅ EXISTING
  useAddRestaurantDataMutation,
  useFetchRestaurantDataQuery,
  useDeleteRestaurantDataMutation,
  useFetchRestaurantDataByIdQuery,
  useFetchSelfRestaurantDataQuery,
  useEditRestaurantDataMutation,
  useUpdateRestaurantSettingMutation,
  
  // ✅ NEW - Multi-location
  useFetchMyLocationsQuery,
  useSwitchLocationMutation,
  useAddLocationMutation,
  useDeleteLocationMutation,
  useCreateLocationPaymentIntentMutation,
  useCheckPaymentStatusQuery,
} = restaruantapi;